import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";
import s from "./ToggleChip.module.css";

export interface ToggleChipProps extends InputHTMLAttributes<HTMLInputElement> {
  children: ReactNode;
}

/** A checkbox group option styled as a plain label chip — no checkbox glyph,
    just the label filling solid when checked. A real `<input
    type="checkbox">`, not a `<button aria-pressed>`: this is a checkbox
    group semantically, and a native checkbox gets group semantics,
    form-control announcement and keyboard behaviour without reimplementing
    them. Hidden with a clip rect rather than `display: none`, so it stays in
    the tab order and inside a focus trap. Wrap a group of these in a
    `<fieldset>` with a `<legend>`. */
export const ToggleChip = forwardRef<HTMLInputElement, ToggleChipProps>(function ToggleChip(
  { children, className, type: _type, ...rest },
  ref,
) {
  const classes = className ? `${s.root} ${className}` : s.root;
  return (
    <label className={classes}>
      <input ref={ref} type="checkbox" className={s.input} {...rest} />
      <span className={s.text}>{children}</span>
    </label>
  );
});
